/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
import { __awaiter, __generator } from "tslib";
import { Mat4, Tensor } from '../../mol-math/linear-algebra';
import { Task } from '../../mol-task';
import { arrayMax, arrayMean, arrayMin, arrayRms } from '../../mol-util/array';
import { CustomProperties } from '../../mol-model/custom-property';
export function volumeFromCube(source, params) {
    var _this = this;
    return Task.create('Create Volume', function () { return __awaiter(_this, void 0, void 0, function () {
        var header, sourceValues, space, values, _a, h, k, l, nth, o, s, u, v, w, data, matrix, basis;
        return __generator(this, function (_b) {
            header = source.header, sourceValues = source.values;
            space = Tensor.Space(header.dim, [0, 1, 2], Float64Array);
            if (header.dataSetIds.length === 0) {
                values = sourceValues;
            }
            else {
                _a = header.dim, h = _a[0], k = _a[1], l = _a[2];
                nth = ((params === null || params === void 0 ? void 0 : params.dataIndex) || 0) + 1;
                o = 0, s = 0;
                values = new Float64Array(h * k * l);
                for (u = 0; u < h; u++) {
                    for (v = 0; v < k; v++) {
                        for (w = 0; w < l; w++) {
                            values[o++] = sourceValues[s];
                            s += nth;
                        }
                    }
                }
            }
            data = Tensor.create(space, Tensor.Data1(values));
            matrix = Mat4.fromTranslation(Mat4(), header.origin);
            basis = Mat4.fromBasis(Mat4(), header.basisX, header.basisY, header.basisZ);
            Mat4.mul(matrix, matrix, basis);
            return [2 /*return*/, {
                    label: params === null || params === void 0 ? void 0 : params.label,
                    entryId: params === null || params === void 0 ? void 0 : params.entryId,
                    grid: {
                        transform: { kind: 'matrix', matrix: matrix },
                        cells: data,
                        stats: {
                            min: arrayMin(values),
                            max: arrayMax(values),
                            mean: arrayMean(values),
                            sigma: arrayRms(values)
                        },
                    },
                    sourceData: CubeFormat.create(source),
                    customProperties: new CustomProperties(),
                    _propertyData: Object.create(null),
                }];
        });
    }); });
}
//
export { CubeFormat };
var CubeFormat;
(function (CubeFormat) {
    function is(x) {
        return (x === null || x === void 0 ? void 0 : x.kind) === 'cube';
    }
    CubeFormat.is = is;
    function create(cube) {
        return { kind: 'cube', name: cube.name, data: cube };
    }
    CubeFormat.create = create;
})(CubeFormat || (CubeFormat = {}));
//# sourceMappingURL=cube.js.map